import clsx from 'clsx'
import { TextFieldProps } from '../../core/_models'
import { Link } from 'react-router-dom'
import { ToolTipUI } from '../UI/ToolTipUI'
import { toAbsoluteUrl } from '../../../../../_metronic/helpers/AssetHelpers'
import '../styles/index.scss'
import { useState } from 'react'
import { useIntl } from 'react-intl'
import { ErrorMessage, Field, getIn } from 'formik'
import { getTodayDate } from '../../../../core/_util'
import { ToolTipUIForModal } from '../UI/ToolTipUIForModal'
import { toast } from 'react-toastify'
import Iccopy from '../../../../../media/EarlyAccess/ic-copy.svg'

const TextInput = ({
  fieldName,
  isForgetPassword,
  label,
  toolTipText,
  placeholder,
  margin,
  formik,
  fieldType,
  isPassword,
  isCheckbox,
  isClickToCopy,
  linkText1,
  linkText2,
  slug1,
  slug2,
  url1,
  url2,
  customText,
  isFieldArray,
  isTooltipNotRequired,
  isBeside,
  width,
  dateValue,
  isDisabled,
  isWidthNotRequired,
  isSocialMedia,
  isStarRequired,
  isRadio,
  value,
  isMargin,
  isImage,
  isImageValue,
  labelWidth,
  isDateField = false,
  isTooltipForModal = false,
  onFocus,
  ariaLabel,
  onBlur,
  isDateOfBirth,
  isMinValue,
  onChange,
  isGreaterThanCommencementDate,
  isLesserThanShareClassFirstClosingDate,
  isLesserThanCovertibleShareDateOFIssue,
  isLesserThanWarrantClassDateOFIssue,
  isLesserShareTransactionDateOfIssue,
  isLabelNone,
  checkboxSize,
}: TextFieldProps) => {
  const [hidePassword, setHidePassword] = useState(true)
  const { formatMessage } = useIntl()
  const FieldArrayErrorMessage = ({ name }: any) => (
    <Field
      name={name}
      render={({ form }: any) => {
        const error = getIn(form.errors, name)
        const touch = getIn(form.touched, name)

        return touch && error ? error : null
      }}
    />
  )

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    formik.setFieldValue(fieldName, e.target.value)
    if (fieldName === 'numberOfShares') {
      if (formik.values.pricePerShare) {
        formik.setFieldValue(
          'totalTransactionValue',
          formik.values.pricePerShare * Number(e.target.value)
        )
        formik.setFieldValue(
          'totalAmountPaid',
          formik.values.pricePerShare * Number(e.target.value)
        )
      }
    }
    if (
      fieldName === 'allDay' ||
      fieldName === 'recordAccess' ||
      fieldName === 'permissionChanges' ||
      fieldName === 'unauthorized' ||
      fieldName === 'linkSharing' ||
      fieldName === 'geoLocation' ||
      fieldName === 'fullAccess' ||
      fieldName === 'uploadFiles' ||
      fieldName === 'recordKeeperAccess' ||
      fieldName === 'importFiles' ||
      fieldName === 'updateFiles' ||
      fieldName === 'addUsers'
    ) {
      formik.setFieldValue(fieldName, e.target.checked)
    }
    if (fieldName === 'warrantIssued') {
      if (formik.values.purchasePerUnit) {
        formik.setFieldValue('amountPaid', formik.values.purchasePerUnit * Number(e.target.value))
      }
    }
    if (fieldName === 'commencementDate') {
      formik.setFieldValue('separationDate', '')
    }
  }

  const handleCopy = (text: string) => {
    navigator.clipboard.writeText(text).then(() => {
      toast.success('Copied Successfully'); // Success toast message
    }).catch((error) => {
      toast.error('Failed to Copy'); // Error toast message
      console.error('Error copying text: ', error);
    });
  };

  return (
    <div
      className={`fv-row  ${!isWidthNotRequired && 'col-12'} ${isBeside
        ? 'd-flex'
        : `${fieldName === 'updateTitle' ? '' : isMargin}  ${isMargin && fieldName !== 'updateTitle' ? isMargin : 'mb-8'
        }`
        } 
      
      ${margin ? margin : 'me-4'} ${width ? `col-md-${width}` : ''}`}
    >
      <div
        className={`d-flex justify-content-between ${isBeside && 'w-md-90px'} ${isBeside && labelWidth
          }  `}
      >
        {
          <label
            className={`${isCheckbox ? 'form-check form-check-inline p-0' : 'form-label'
              } ${isLabelNone ? 'd-none' : ''}  font-size-13  text-dark text-capitalize  ms-md-0 ${isBeside && isTooltipNotRequired
                ? 'd-flex align-items-md-center  fw-normal mb-0 col-md-12'
                : 'd-flex flex-md-row align-items-md-center '
              }`}
            htmlFor='kt_login_toc_agree'
          >
            {isStarRequired ? (
              !isTooltipNotRequired ? (
                <>
                  {label}*{' '}
                  {isTooltipForModal ? (
                    <ToolTipUIForModal tooltipText={formatMessage({ id: toolTipText })} />
                  ) : (
                    <ToolTipUI tooltipText={toolTipText} />
                  )}
                </>
              ) : (
                <>{label}*</>
              )
            ) : !isTooltipNotRequired ? (
              <>
                {label}{' '}
                {isTooltipForModal ? (
                  <ToolTipUIForModal tooltipText={formatMessage({ id: toolTipText })} />
                ) : (
                  <ToolTipUI tooltipText={toolTipText} />
                )}
              </>
            ) : (
              <>{label}</>
            )}
          </label>
        }

        {isForgetPassword && (
          <div className='d-flex flex-stack flex-wrap gap-3 fs-base fw-bold '>
            {/* begin::Link */}
            <Link to='/auth/forgot-password' className='text-clr477'>
              {formatMessage({ id: 'Forgot Password' })} ?
            </Link>
            {/* end::Link */}
          </div>
        )}
      </div>
      <div className='d-md-flex flex-md-column w-100'>
        <div className={`position-relative d-flex  ${isBeside && 'w-md-50'}`}>
          {isRadio ? (
            <Field
              // id='t_login_toc_agree'
              className={`${isCheckbox ? 'form-check-input ' : clsx('form-control h-40px font-size-12')
                }`}
              type={fieldType}
              name={fieldName}
              value={isRadio && value}
            />
          ) : (
            <Field
              // id='t_login_toc_agree'
              className={`${isCheckbox
                ? `form-check-input h-${checkboxSize ? checkboxSize : 30}px w-${checkboxSize ? checkboxSize : 30}px`
                : clsx(
                  'form-control h-40px font-size-12 ',
                  {
                    'is-invalid-local':
                      !isSocialMedia && formik.touched[fieldName] && formik.errors[fieldName],
                  },
                  {
                    'is-valid-local':
                      !isSocialMedia && formik.touched[fieldName] && !formik.errors[fieldName],
                  },
                  {
                    'is-invalid-local':
                      isSocialMedia &&
                      formik.touched &&
                      formik.touched[`socialMedia`] &&
                      formik.touched[`socialMedia`][fieldName.split('.')[1]] &&
                      formik.errors &&
                      formik.errors[`socialMedia`] &&
                      formik.errors[`socialMedia`][fieldName.split('.')[1]],
                  },
                  {
                    'is-valid-local':
                      isSocialMedia &&
                      formik.touched &&
                      formik.touched[`socialMedia`] &&
                      formik.touched[`socialMedia`][fieldName.split('.')[1]] &&
                      formik.errors &&
                      formik.errors[`socialMedia`] &&
                      !formik.errors[`socialMedia`][fieldName.split('.')[1]],
                  }
                )
                }`}
              type={hidePassword && isPassword ? 'password' : fieldType}
              disabled={isDisabled}
              name={fieldName}
              defaultValue={dateValue && new Date(dateValue).toISOString().substr(0, 10)}
              placeholder={placeholder}
              autoComplete='off'
              onChange={onChange ? (e: any) => onChange(e) : handleChange}
              min={
                isMinValue
                  ? 0
                  : isDateField
                    ? getTodayDate()
                    : isGreaterThanCommencementDate
                      ? formik.values.commencementDate
                      : isLesserThanShareClassFirstClosingDate
                        ? formik?.values?.shareClassId?.firstClosingDate
                        : isLesserThanCovertibleShareDateOFIssue
                          ? formik?.values?.convertibleClassId?.dateOfIssue
                          : isLesserThanWarrantClassDateOFIssue
                            ? formik?.values?.warrantClassId?.boardApprovalDate
                            : isLesserShareTransactionDateOfIssue
                              ? formik?.values?.shareTransactionId?.dateOfIssue
                              : undefined
              }
              max={isDateOfBirth && getTodayDate()}
              onFocus={onFocus}
              onBlur={onBlur}
              aria-label={ariaLabel}
            />
          )}
          {isCheckbox && (
            <span className='d-flex flex-row ms-3 ms-md-3 fw-semibold position-relative align-items-center'>
              {isImage && <img src={isImageValue} className='pe-3' alt='' />}
              {customText}
              {linkText1 && linkText2 && (
                <>
                  {/* <Link to={`${slug1}`} className='ms-1 link-primary'>
                    {linkText1}
                  </Link>{' '}
                  &{' '}
                  <Link to={`${slug2}`} className='ms-1 link-primary'>
                    {linkText2}
                  </Link> */}
                  <a
                    href={`${url1}`}
                    className='mx-1 link-primary'
                    target='_blank'
                    rel='noreferrer'
                  >
                    {linkText1}
                  </a>{' '}
                  &{' '}
                  <a
                    href={`${url2}`}
                    className='mx-1 link-primary'
                    target='_blank'
                    rel='noreferrer'
                  >
                    {linkText2}
                  </a>
                </>
              )}
            </span>
          )}

          {isPassword && (
            <div
              className='password'
              id='button-addon2'
              role='button'
              onClick={() => setHidePassword(!hidePassword)}
            >
              <img
                src={toAbsoluteUrl(
                  hidePassword
                    ? '/media/icons/duotune/general/eyeHide.svg'
                    : '/media/icons/duotune/general/eye.png'
                )}
                width='24px'
                height='24px'
                alt='eye'
              />
            </div>
          )}
          {isClickToCopy && <button
            type="button"
            className="btn bg-transparent position-absolute"
            style={{ top: '50%', right: '0px', transform: 'translateY(-50%)' }}
            onClick={(e) => handleCopy(formik.values[fieldName])}
            aria-label="Copy text"
          >
            <img
              src={Iccopy}
              width="15px"
              height="15px"
              alt="copy"
            />
          </button>}
        </div>

        <div className='text-danger mt-2'>
          {isFieldArray ? (
            <FieldArrayErrorMessage name={fieldName} />
          ) : (
            <ErrorMessage name={fieldName} />
          )}
        </div>
      </div>
    </div>
  )
}

export default TextInput
